import * as Immutable from 'immutable';
import UIDataStore, { Price } from '../_stores/UIDataStore';
import Fabrics, { Fabric, FabricInfo, FabricSize } from '../_data/Fabrics';
import { UIDataAction, UIDataActionType } from '../_actions/UIDataActions';
import { AjaxActionStart, AjaxActionEnd, AjaxActionStartType, AjaxActionEndType } from '../../Common/_actions/AjaxAction';

const UIDataReducer = (store:UIDataStore = new UIDataStore(), action: UIDataAction | AjaxActionStart | AjaxActionEnd):UIDataStore => {
	switch (action.type) {
		case UIDataActionType.Toast:
			return store.withMutations(store => {
				store.setIn(['toast', 'new'], true);
				store.setIn(['toast', 'message'], action.message);
			});

		case UIDataActionType.ConsumeToast:
			return store.withMutations(store => {
				store.setIn(['toast', 'new'], false);
				store.setIn(['toast', 'message'], "");
			});

		case UIDataActionType.EditCountries:
			return store.set('countries', Immutable.fromJS(action.countries, function (key, value, path) {
				return Immutable.isKeyed(value) ? value.toOrderedMap() : value.toList()
			}));

		case UIDataActionType.EditLoader:
			return store.setIn(['loaders', action.loader], action.value);

		case UIDataActionType.EditSignupStatus:
			return store.set('signupStatus', action.status);

		case UIDataActionType.EditPasswordStatus:
			return store.set('passwordStatus', action.status);

		case UIDataActionType.EditCartStatus:
			return store.set('cartStatus', action.status);

		case UIDataActionType.EditFabrics:
			return store.withMutations((store) => {
				for(let fabricId in action.fabrics) {
					let fabric = action.fabrics[fabricId];

					let sizes = Immutable.Map<number, FabricSize>();

					for(let sizeId in fabric.sizes) {
						let fabricSize = fabric.sizes[sizeId];

						let priceObject = new Price(fabricSize.price);

						let fabricSizeObject = new FabricSize({
							'slug': fabricSize.slug,
							'name': fabricSize.name,
							'price': priceObject,
							'width': fabricSize.width,
							'height': fabricSize.height,
						});

						sizes = sizes.set(+sizeId, fabricSizeObject);
					}

					let info = new FabricInfo(Fabrics[fabric.slug]);

					let fabricObject = new Fabric({
						'slug': fabric.slug,
						'name': fabric.name,
						'category': fabric.category,
						'sizes': sizes,
						'info': info
					});

					store.setIn(['fabrics', +fabricId], fabricObject);
				}
			});

		case UIDataActionType.SetOrderingStatus:
			return store.withMutations((store) => {
				if(!action.status) store.setIn(['ordering', 'id'], undefined);
				store.setIn(['ordering', 'status'], action.status);
			});

		case UIDataActionType.OrderProduct:
			return store.withMutations((store) => {
				store.setIn(['ordering', 'id'], action.id);
				store.setIn(['ordering', 'productType'], action.productType);
				store.setIn(['ordering', 'status'], true);
			});

		case AjaxActionStartType :
		case AjaxActionEndType :
			let loading = action.type == AjaxActionStartType;
			if(action.url == 'ajax/info/get-fabrics')							store = store.setIn(['loaders', 'fabrics'], loading);
			if(action.url == '/static/data/countries.json')						store = store.setIn(['loaders', 'countries'], loading);
			if(action.url == 'ajax/user/addresses/get-user-addresses')			store = store.setIn(['loaders', 'addresses'], loading);
			if(action.url == 'ajax/user/credit-cards/get-user-credit-cards')	store = store.setIn(['loaders', 'creditCards_all'], loading);
			if(action.url == 'ajax/user/credit-cards/create-user-credit-card')	store = store.setIn(['loaders', 'creditCards_single'], loading);
			if(action.url == 'ajax/cart/save-cart-address')						store = store.setIn(['loaders', 'cart_address'], loading);

			if(action.url == 'ajax/cart/save-cart-address')						store = store.setIn(['loaders', 'cart'], loading);
			if(action.url == 'ajax/cart/delete-cart-item')						store = store.setIn(['loaders', 'cart'], loading);
			if(action.url == 'ajax/cart/get-user-cart')							store = store.setIn(['loaders', 'cart'], loading);
			if(action.url == 'ajax/cart/update-cart-shipping-type')				store = store.setIn(['loaders', 'cart'], loading);

			if(action.url == 'ajax/cart/update-cart-item')						store = store.setIn(['loaders', 'cart_item'], loading);

			if(action.url == 'ajax/create/upload-file')							store = store.setIn(['loaders', 'images'], loading);
			
			if(
				action.url.match("ajax\/create\/get-pattern-categories") ||
				(action.url.match("ajax\/create\/get-pattern-designs") && loading)
			) store = store.setIn(['loaders', 'patterns'], loading);
		break;

	}

	return store;
}

export default UIDataReducer